/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetFragmentSocialUploadsUploadByIdQueryResponse, GetFragmentSocialUploadsUploadByIdPathParams } from "../models/GetFragmentSocialUploadsUploadById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getFragmentSocialUploadsUploadById } from "../axios/getFragmentSocialUploadsUploadById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getFragmentSocialUploadsUploadByIdQueryKey = (uploadId: GetFragmentSocialUploadsUploadByIdPathParams["uploadId"]) => ["web-app-bff-api", { url: '/fragment-social-uploads/:uploadId', params: {uploadId:uploadId} }] as const

export type GetFragmentSocialUploadsUploadByIdQueryKey = ReturnType<typeof getFragmentSocialUploadsUploadByIdQueryKey>

export function getFragmentSocialUploadsUploadByIdQueryOptions(uploadId: GetFragmentSocialUploadsUploadByIdPathParams["uploadId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getFragmentSocialUploadsUploadByIdQueryKey(uploadId)
        return queryOptions<GetFragmentSocialUploadsUploadByIdQueryResponse, ResponseErrorConfig<Error>, GetFragmentSocialUploadsUploadByIdQueryResponse, typeof queryKey>({
         enabled: !!(uploadId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getFragmentSocialUploadsUploadById(uploadId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a single social upload by id
 * {@link /fragment-social-uploads/:uploadId}
 */
export function useGetFragmentSocialUploadsUploadById<TData = GetFragmentSocialUploadsUploadByIdQueryResponse, TQueryData = GetFragmentSocialUploadsUploadByIdQueryResponse, TQueryKey extends QueryKey = GetFragmentSocialUploadsUploadByIdQueryKey>(uploadId: GetFragmentSocialUploadsUploadByIdPathParams["uploadId"], options: 
{
  query?: Partial<QueryObserverOptions<GetFragmentSocialUploadsUploadByIdQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getFragmentSocialUploadsUploadByIdQueryKey(uploadId)
         

         const query = useQuery({
          ...getFragmentSocialUploadsUploadByIdQueryOptions(uploadId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}